__webpack_require__.p = "/mock-trader-full-stack/";